<tr class="question-row" [ngClass]="{ active: isSelected }">
  <td
    (click)="selectRow.emit(rowIndex)"
    class="row-num"
    title="Click to select row"
  >
    {{ rowIndex + 1 }}
  </td>

  @for (cell of tableCells; track cell) { @if (!cell.question.hidden &&
  !cell.question.toggleOff) {
  <td
    (click)="cellClick(cell)"
    class="{{ question.lockType }}"
    id="{{ 'question-table-warning-' + cell.question.id }}"
    [ngClass]="{
      highlighted: cell.answer.overrideStatus || cell.answer.answerChanged,
      active: cell.answer?.isActive,
      error:
        cell.question.mandatory &&
        (cell.formControl
          ? !cell.formControl?.value
          : cell.answer.answer == ''),
      disabled: isQuestionAlwaysEditable(
        cell.question,
        readonlyGlobal || deleted
      ),
      'active-warning': hasWarnings(cell.answer),
      'checkbox-column': cell.question.isBooleanCheckbox,
      nonEmpty: getControl(question).value
    }"
  >
    @if (!cell.answer?.isActive) {
    <div
      class="answer"
      [ngClass]="{ checkbox: cell.question.isBooleanCheckbox }"
    >
      @if (!cell.question.isBooleanCheckbox) {
      <div
        class="value"
        appTooltip
        [showOnTruncate]="true"
        [content]="cell.formControl?.value"
      >
        {{ cell.question | answerDisplay: cell.displayAnswer }}
      </div>
      } @if (cell.question.isBooleanCheckbox) { @if ( cell.formControl ?
      cell.formControl.value : cell.answer.answer === 'true' ) {
      <div class="blue tick icon"></div>
      } @if ( cell.formControl ? !cell.formControl?.value : cell.answer.answer
      !== 'true' ) {
      <div class="grey circle outline icon"></div>
      } }
      <div class="dots">
        @if ( cell.formControl?.valid === false || hasWarnings(cell.answer,
        false) ) {
        <div
          [ngClass]="{
            active:
              cell.formControl?.valid === false ||
              hasWarnings(cell.answer, true)
          }"
          class="dot warning"
        ></div>
        } @if (hasFlags(cell.answer, false)) {
        <div
          [ngClass]="{ active: hasFlags(cell.answer, true) }"
          class="dot flag"
        ></div>
        } @if (hasComments(cell.answer)) {
        <div class="dot comment"></div>
        }
      </div>
      @if ( !isQuestionAlwaysEditable(cell.question, readonlyGlobal || deleted)
      ) {
      <div class="hover-options">
        @if (!inspectMode && !cell.question.isBooleanCheckbox) {
        <i class="pencil icon"></i>
        } @if (!inspectMode) {
        <i
          class="icon comment alternate outline"
          (click)="
            labelClick(cell.question, cell.answer); $event.stopPropagation()
          "
        ></i>
        }
      </div>
      }
    </div>
    } @if ( cell.answer?.isActive && cell.formControl &&
    !isQuestionAlwaysEditable(cell.question, readonlyGlobal || deleted) ) {
    <div>
      <app-form-field-wrapper
        (clickOutside)="onCellBlur(cell)"
        [delayClickOutsideInit]="true"
        [formGroup]="formGroup"
        [groupId]="groupId"
        [questions]="subGroup?.questions"
        [question]="cell.question"
        [row]="rowIndex"
        [disabled]="
          isQuestionAlwaysEditable(cell.question, readonlyGlobal || deleted)
        "
        [autofocus]="true"
      ></app-form-field-wrapper>
    </div>
    } @if (showOverRideQuestion(cell.answer)) {
    <i class="eraser icon" (click)="overRideAnswer(cell.answer, cell)"></i>
    }
  </td>
  } }
</tr>
